import { INSERT_LEADS } from '../constants/urls';
import zfetch, { METHOD_POST } from '../pages/common/utils/zfetch';

export const insertLead = payload => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(payload),
  };

  return zfetch(INSERT_LEADS, options).then(res => res.json());
};
